import {
  RSAuthenticate,
  getAuthToken,
} from '../../utils/auth/authentication.js';
import { Configuration, DefaultApi, HTTPHeaders } from '@rtkwlf/rendall';
export const AUTH_TOKEN = 'access_token';

/**
 * This hook enables to make end point calls to Rendall backend through Open
 * API generated models and api client. Since Rendall base urls are based on
 * Organization's Region it uses the selected org's pod.
 *
 * @param headers HTTP Headers for fetch call.
 * @returns Returns Rendall api client to make fetch requests with Authentication Headers included.
 */

/**
 * Usage: Example
 * Import useRendallApi hook.
 * const api = useRendallApi();
 * async () => api.getContactInfo()
 * **/

export const useRendallApi = (headers?: HTTPHeaders): DefaultApi => {
  const basePath = (() => {
    const isE2eTesting = window.localStorage.getItem('e2e_testing');
    const enableProd = window.localStorage.getItem('enable_prod');
    const pod = window.localStorage.getItem('apiPod');
    const host = window.location.hostname;

    if (
      host === 'risk.global-test.arcticwolf.net' ||
      (host === 'localhost' && enableProd !== 'true')
    )
      return 'https://rendall.rendall.protontest.us001-test.rtkwlf.io';

    if (isE2eTesting === 'true') return 'http://localhost:8080';
    else {
      return pod && pod !== 'n/a'
        ? `https://rendall.managedgw.${pod}.arcticwolf.net`
        : 'https://rendall.managedgw.us001-prod.arcticwolf.net'; // fallback case, should almost never get hit
    }
  })();

  /**
   * Set access token to the returned promise from getAuthToken()
   * after authentication has been refreshed.
   *
   * RSAuthenticate maintains a single promise whether started
   * by this call, or the one in index-init.js
   */
  const api = new DefaultApi(
    new Configuration({
      basePath,
      headers,
      accessToken: RSAuthenticate().then(
        () => getAuthToken() as Promise<string>
      ),
    })
  );
  return api;
};
